import { memo } from "react";
import Box from "@mui/material/Box";
import { WebRoutes } from "consts/enpoints/web";
import { Navigate } from "infrastructure/router";
import {
    BusinessInformationLabel,
    DirectorsAndShareholdersLabel,
    FinancialInformationLabel,
    PaymentMethodsLabel,
    RiskAndComplianceLabel,
    MarketingWebsiteAndSupportLabel,
    UploadDocumentsLabel,
    Complete
} from "./steps";
import { Stats, OnboardingLayout } from "../common";
import { useOnboardingApplication } from "./hooks";

const OnboardingComplete = () => {
    const {
        isApplicationCompleted,
        isApplicationSubmitted,
        getApplicationModel
    } = useOnboardingApplication();

    const labelSx = {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        px: 2,
        py: 1
    };

    switch (true) {
        // Appication is submitted and completed, redirect to home page
        case (
            isApplicationSubmitted() &&
            isApplicationCompleted()
        ): {
                return (
                    <Navigate
                        to={WebRoutes.Root}
                        replace
                    />
                );
            }

        // Application is not submitted, but completed, show complete step
        case (
            !isApplicationSubmitted() &&
            isApplicationCompleted()
        ): {
                return (
                    <OnboardingLayout>
                        <Complete
                            slots={{
                                stats: (
                                    <Stats
                                        sx={{
                                            color: 'primary.main'
                                        }}
                                        route={WebRoutes.Onboarding.HighRiskMerchant}
                                        getApplicationModel={getApplicationModel}
                                    />
                                )
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: .5
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'grid',
                                        alignSelf: 'flex-start',
                                        gap: 1
                                    }}
                                >
                                    {[
                                        BusinessInformationLabel,
                                        DirectorsAndShareholdersLabel,
                                        FinancialInformationLabel,
                                        PaymentMethodsLabel,
                                        RiskAndComplianceLabel,
                                        MarketingWebsiteAndSupportLabel
                                    ].map((Component, index) => (
                                        <Component
                                            key={index}
                                            sx={labelSx}
                                        />
                                    ))}
                                </Box>
                                <UploadDocumentsLabel
                                    sx={labelSx}
                                />
                            </Box>
                        </Complete>
                    </OnboardingLayout>
                );
            }

        // For rest of the cases, redirect to onboarding index (Getting Started), that guy will handle the rest ;)
        default: {
            return (
                <Navigate
                    to={WebRoutes.Onboarding.HighRiskMerchant.Index}
                    replace
                />
            );
        }
    }
};

export default memo(OnboardingComplete);
